
import React from 'react';
import { useApp } from '../../context/AppContext';
import { ArrowLeft } from 'lucide-react';
import RegisterForm from './RegisterForm';

const Register: React.FC = () => {
  const { register, setCurrentScreen } = useApp();

  const handleRegister = (email: string, phone: string, password: string) => {
    register(email, phone, password);
  };

  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center mb-8 pt-4">
        <button 
          onClick={() => setCurrentScreen('welcome')}
          className="p-2 rounded-full hover:bg-gray-100"
        >
          <ArrowLeft className="w-6 h-6" />
        </button>
        <h1 className="text-2xl font-bold ml-4">Sign Up</h1>
      </div>

      <RegisterForm 
        onSubmit={handleRegister}
        onLoginClick={() => setCurrentScreen('login')}
      />
    </div>
  );
};

export default Register;
